module.exports = __webpack_public_path__ + "static/media/1POLICY30.eff85931.jpg";